<template>
  <full-container v-loading="loading">
    <!--工具条-->
    <div slot="header" class="toolbar">
      <ul class="tabs">
        <li
          v-for="(item, index) in modeOptions"
          :key="index"
          :class="{ selected: queryParams.mode == item.value }"
          @click="
            queryParams.mode = item.value
            onSearch()
          "
        >
          {{ item.text }}
        </li>
      </ul>
      <el-form ref="ff" size="small" :inline="true" :model="queryParams" class="search-form">
        <el-form-item>
          <regions :current.sync="queryParams.region" placeholder="地区筛选" />
        </el-form-item>
        <el-form-item>
          <categories :current.sync="queryParams.category" placeholder="品类筛选" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetForm">重置</el-button>
        </el-form-item>
        <el-popover>
          <el-button slot="reference" size="small" type="text">
            更多查询
            <i class="el-icon-arrow-down"></i>
          </el-button>
          <el-form-item label="采购单位">
            <el-input v-model="queryParams.purchaser" clearable />
          </el-form-item>
          <el-form-item label="经销商">
            <el-input v-model="queryParams.dealer" clearable />
          </el-form-item>
          <el-form-item label="品名/编号">
            <el-input v-model="queryParams.product" clearable />
          </el-form-item>
          <el-form-item label="时段">
            <el-date-picker v-model="queryParams.dealtime" type="monthrange" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期" />
          </el-form-item>
        </el-popover>
      </el-form>
    </div>
    <!--表格-->
    <el-table :data="datalist.Items" height="100%">
      <el-table-column prop="Mode" label="采购方式" min-width="72" show-overflow-tooltip />
      <el-table-column prop="Title" label="分类/品牌" min-width="100" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <template v-if="row.Category == '暂未分类'">
            <el-select size="mini" v-model="row.Category" placeholder="品类筛选" @change="setCategory(row)">
              <el-option label="计算机设备" value="计算机设备" />
              <el-option label="办公设备" value="办公设备" />
              <el-option label="办公用品" value="办公用品" />
              <el-option label="办公用纸" value="办公用纸" />
              <el-option label="办公耗材" value="办公耗材" />
              <el-option label="数码设备" value="数码设备" />
              <el-option label="生活电器" value="生活电器" />
              <el-option label="家具用具" value="家具用具" />
              <el-option label="日用百货" value="日用百货" />
              <el-option label="服务" value="服务" />
              <el-option label="其它" value="其它" />
            </el-select>
          </template>
          <template v-else>
            <label style="color: #000">{{ row.Category }}</label>
            {{ row.Brand }}
          </template>
        </template>
      </el-table-column>
      <el-table-column label="采购单位" min-width="150" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <label style="color: #000">{{ row.Region }}</label>
          {{ row.Purchaser }}
        </template>
      </el-table-column>
      <el-table-column prop="Title" label="品名" min-width="200" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <el-link type="primary" v-if="row.Mode == '政采超市'" :href="`https://www.zcygov.cn/items/${row.Code}`" target="_blank">{{ row.Title }}</el-link>
          <template v-if="row.Mode == '在线询价'">
            <el-link type="primary" v-if="row.Variety == 'inquiryhall'" :href="`https://inquiryhall.zcygov.cn/inquiryhall/result?inquiryId=${row.Code}`" target="_blank">{{ row.Title }}</el-link>
            <el-link type="primary" v-else :href="`https://zxxj.zcygov.cn/bidding/detail?type=BIDDING_COMPLETED&requisitionId=${row.Code}`" target="_blank">{{ row.Title }}</el-link>
          </template>
          <template v-if="row.Mode == '反向竞价'">
            <el-link type="primary" v-if="row.Variety == 'reversehall'" :href="`https://reversehall.zcygov.cn/result?id=${row.Code}`" target="_blank">{{ row.Title }}</el-link>
            <el-link type="primary" v-else :href="`https://fxjj.zcygov.cn/bidding/detail?type=BIDDING_COMPLETED&requisitionId=${row.Code}`" target="_blank">{{ row.Title }}</el-link>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="Price" label="单价" min-width="80" align="center" />
      <el-table-column prop="Quantity" label="数量" min-width="60" align="center" />
      <el-table-column prop="Dealer" label="经销商" min-width="150" show-overflow-tooltip />
      <el-table-column label="成交时间" min-width="100" align="center">
        <template slot-scope="{ row }">
          {{ $utils.common.parseTime(row.DealTime) }}
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="toolbar" slot="footer">
      <el-button id="autoBtn" type="warning" size="small" @click="autoClass()" v-if="queryParams.category == '暂未分类'">默认检测分类</el-button>
      <el-pagination background :page-size="datalist.PageSize" :current-page="datalist.PageIndex" :total="datalist.TotalCount" @current-change="onPager" />
    </div>
  </full-container>
</template>

<script>
export default {
  components: {
    categories: () => import("./auth/_categories.vue"),
    regions: () => import("./auth/_regions.vue")
  },
  data () {
    return {
      loading: false,
      modeOptions: [
        { text: '全部' },
        { text: '政采超市', value: '政采超市' },
        { text: '在线询价', value: '在线询价' },
        { text: '反向竞价', value: '反向竞价' }
      ],
      datalist: null,
      queryParams: null,
    }
  },
  created () {
    this.resetForm()
  },
  methods: {
    // 查询参数
    onSearch () {
      this.queryParams.index = 1
      this.loadData()
    },
    resetForm () {
      this.queryParams = { index: 1, size: 30, ...this.$route.params }
      this.loadData()
    },
    // 分页触发事件
    onPager (val) {
      this.queryParams.index = val
      this.loadData()
    },
    // 信息列表
    loadData () {
      if (this.loading) { return }
      this.loading = true
      this.$apis.trend.source.list(this.queryParams).then((res) => {
        this.datalist = res
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    },
    setCategory (row) {
      this.$apis.trend.source.setCategory({
        id: row.Code,
        category: row.Category
      }).catch((e) => {
        this.$message.error(e)
      })
    },
    autoClass () {
      const loading = this.$loading({
        target: document.getElementById("autoBtn"),
        text: "loading"
      })
      this.$apis.trend.source.setCategory().then(() => {
        this.loadData()
        this.$message({
          message: '自检完成',
          type: 'success'
        })
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>


<style lang="scss" scoped>
ul.tabs {
  display: flex;
  padding: 0 16px;
  li {
    list-style: none;
    padding: 5px 0;
    position: relative;
    cursor: pointer;
  }
  li + li {
    margin-left: 20px;
  }
  li.selected {
    color: #409eff;
  }
  li.selected::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    height: 3px;
    width: 100%;
    background: #409eff;
  }
}
</style>